import { create } from 'zustand';

type FilterStore = {
  isOpenFilter: boolean;
  searchTerm: string;
  filterSelections: Record<string, string[]>;
  activeFilters: string[];

  setIsOpenFilter: (isOpenFilter: boolean) => void;
  openModal: () => void;
  setSearchTerm: (term: string) => void;
  updateFilterSelections: (category: string, values: string[]) => void;
  clearFilters: () => void;
};

export const useFilterStore = create<FilterStore>((set) => ({
  isOpenFilter: false,
  searchTerm: '',
  filterSelections: {},
  activeFilters: [],

  setIsOpenFilter: (isOpenFilter) => set({ isOpenFilter }),
  openModal: () => set((state) => ({ isOpenFilter: !state.isOpenFilter })),
  setSearchTerm: (term) => set({ searchTerm: term }),

  updateFilterSelections: (category, values) =>
    set((state) => {
      const newFilterSelections = { ...state.filterSelections };

      if (values.length === 0) {
        delete newFilterSelections[category];
      } else {
        newFilterSelections[category] = values;
      }

      const newActiveFilters =
        values.length > 0
          ? state.activeFilters.includes(category)
            ? state.activeFilters
            : [...state.activeFilters, category]
          : state.activeFilters.filter((cat) => cat !== category);

      return {
        filterSelections: newFilterSelections,
        activeFilters: newActiveFilters,
      };
    }),

  clearFilters: () =>
    set({
      filterSelections: {},
      activeFilters: [],
      searchTerm: '',
    }),
}));
